import React from 'react';
import useServicesPerYearDonutChart from './hooks/useServicesPerYearDonutChart';
import { Donut } from '../../../Common/Charts/Donut';

export const ServicesPerYearDonut = ({ height }) => {
    const { series, subtitles } = useServicesPerYearDonutChart();


    return (
        <Donut
            labelsOutside
            height={height}
            title={`Tipo de Financiamento Federal`}
            series={series}
            subtitles={subtitles}
            chartData={[]}
            isMoney
        />
    );
};
